module.exports = __webpack_public_path__ + "img/info-generic-pizza.c7d981e2.jpg";